import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"
import _imports_0 from '@/assets/vetdata-Logo.jpg'


const _hoisted_1 = {
  key: 0,
  class: "topLeftIcon"
}
const _hoisted_2 = { class: "feedbackEmailLink" }
const _hoisted_3 = {
  class: "pr-3",
  style: {"width":"70px"}
}
const _hoisted_4 = {
  key: 0,
  class: "mr-6"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "d-inline mr-10" }
const _hoisted_15 = { class: "d-inline mr-10" }
const _hoisted_16 = { class: "d-inline mr-10" }
const _hoisted_17 = { class: "d-inline mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_auto_logout = _resolveComponent("auto-logout")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_header_notification = _resolveComponent("header-notification")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_agb_confirm_dialog = _resolveComponent("agb-confirm-dialog")!
  const _component_startup_message_dialog = _resolveComponent("startup-message-dialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "inspire" }, {
    default: _withCtx(() => [
      _createVNode(_component_loading_spinner),
      (_ctx.$vuetify.display.lgAndUp && _ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            app: "",
            rail: _ctx.isMiniVariant
          }, {
            default: _withCtx(() => [
              _createVNode(_component_navigation, {
                "is-mini-variant": _ctx.isMiniVariant,
                onMiniVariantChanged: _ctx.miniVariantChanged
              }, null, 8, ["is-mini-variant", "onMiniVariantChanged"])
            ]),
            _: 1
          }, 8, ["rail"]))
        : (_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
              key: 1,
              modelValue: _ctx.drawer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
              app: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_navigation)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
      _createVNode(_component_v_app_bar, {
        app: "",
        dark: "",
        color: "primary"
      }, {
        default: _withCtx(() => [
          (!_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_img, {
                  src: _imports_0,
                  height: "64"
                })
              ]))
            : (_ctx.$vuetify.display.mdAndDown)
              ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                  key: 1,
                  onClick: [
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMiniVariant = !_ctx.isMiniVariant)),
                    _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
                  ]
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.subTitle)), 1)
            ]),
            _: 1
          }),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_auto_logout, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "pr-4 pt-1",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMailToFeedback({ lang: _ctx.language, senderInfo: _ctx.benutzerInfo, screen: _ctx.footerTitle })))
              }, [
                _createElementVNode("u", _hoisted_2, _toDisplayString(_ctx.$t('Feedback E-Mail')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_select, {
              id: "languageSelect",
              class: "language-select",
              items: _ctx.languages,
              "hide-details": "",
              dense: "",
              "model-value": _ctx.language.toUpperCase(),
              "onUpdate:modelValue": _ctx.changeLanguage
            }, null, 8, ["items", "model-value", "onUpdate:modelValue"])
          ]),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 4,
                bottom: "",
                color: "secondary"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                    _createVNode(_component_v_btn, {
                      style: {"cursor":"default"},
                      icon: "",
                      class: "mr-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { "x-large": "" }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-account-cog")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (!_ctx.$vuetify.display.xs)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                          (_ctx.benutzerInfo.tvsKundenNummer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_ctx.$t('tvs.nr')) + ": ", 1),
                                _createElementVNode("b", null, _toDisplayString(_ctx.benutzerInfo.tvsKundenNummer), 1)
                              ]))
                            : (_ctx.benutzerInfo.tvsLieferantenNummer)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('lieferant.nr')) + ": ", 1),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.benutzerInfo.tvsLieferantenNummer), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.benutzerInfo.anzeigeName), 1),
                                  (_ctx.benutzerInfo.isKontextSet)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_ctx.benutzerInfo.teilnehmerName) + " - " + _toDisplayString(_ctx.benutzerInfo.teilnehmerId) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                        ]))
                      : _createCommentVNode("", true)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, [
                      (_ctx.$vuetify.display.xs)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                            (_ctx.benutzerInfo.tvsKundenNummer)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('tvs.nr')) + ": ", 1),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.benutzerInfo.tvsKundenNummer), 1)
                                ]))
                              : (_ctx.benutzerInfo.tvsLieferantenNummer)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('lieferant.nr')) + ": ", 1),
                                    _createElementVNode("b", null, _toDisplayString(_ctx.benutzerInfo.tvsLieferantenNummer), 1)
                                  ]))
                                : _createCommentVNode("", true),
                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", null, _toDisplayString(_ctx.benutzerInfo.anzeigeName), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                      (_ctx.benutzerInfo.rollen)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(_ctx.$t('benutzerrollen.' + _ctx.benutzerInfo.rollen.toString().toLowerCase()).toString()), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn && _ctx.permissions.length > 0)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 5,
                icon: "",
                link: "",
                to: { name: 'Login' },
                onClick: _ctx.logout
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-logout")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_header_notification)
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, { class: "accent" }, {
        default: _withCtx(() => [
          _createVNode(_component_agb_confirm_dialog, { onOpenagblink: _ctx.openAgbInNewTab }, null, 8, ["onOpenagblink"]),
          _createVNode(_component_startup_message_dialog),
          ((_ctx.isLoggedIn && !_ctx.hasAccess('Navigation.GuiAccess') && _ctx.permissions.length > 0) || _ctx.accessDenied)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pl-9" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("h2", null, "Keinen Zugriff", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("p", null, "Sie besitzen nicht die nötigen Rechte um auf diese Seite zuzugreifen.", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            small: "",
                            color: "primary",
                            onClick: _ctx.logout
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('login.button.logout')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        color: "grey",
        app: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, "[" + _toDisplayString(_ctx.footerTitle) + "]", 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.timestamp), 1),
            _createElementVNode("div", _hoisted_16, "© " + _toDisplayString(_ctx.currentYear), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.AppTitle) + " V" + _toDisplayString(_ctx.AppVersion) + " " + _toDisplayString(_ctx.AppEnviroment), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}